exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "form[data-v-f9a5d8a2]{padding:40px}.error[data-v-f9a5d8a2]{display:block;color:red;margin:10px 0}.closeButton[data-v-f9a5d8a2]{position:absolute;right:10px;top:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f9a5d8a2","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/Account/address-modal.vue
// module id = 6XTG
// module chunks = 116